import { FunctionComponent } from 'react'
import { MinutesSelect } from '../minutes-select'
import { HourSelect } from '../hour-select'
import { TabCronProp } from '@/types/cron'
import { INPUT_FIELD_CLASSNAME } from '@/constants/classname/classname'

const MonthlyCron: FunctionComponent<TabCronProp> = (props) => {
    // const [state, setState] = useState<MonthlyState>({ hour: 0, minute: 0, every: "1" })

    {/* TODO This settings doesnot work with quartz system. Update this in future */ }
    // useEffect(() => {
    //     let every
    //     if (props.value[3] === 'L') {
    //         every = "2"
    //     } else if (props.value[3] === 'LW') {
    //         every = "3"
    //     } else if (props.value[3].startsWith('L')) {
    //         every = "4"
    //     } else {
    //         every = "1"
    //     }
    //     setState({ ...state, every: every })
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])

    const onDayChange = (e: { target: { value: string } }) => {
        if (props.disabled) { return }
        if (((parseInt(e.target.value) > 0 && parseInt(e.target.value) <= 31)) || e.target.value === "") {
            const val = ['0', props.value[1] === '*' ? '0' : props.value[1], props.value[2] === '*' ? '0' : props.value[2], props.value[3], '1/1', '?', '*']
            val[3] = `${e.target.value}`
            props.onChange(val)
        }
    }

    {/* TODO This settings doesnot work with quartz system. Update this in future */ }
    // const onLastDayChange = (e: { target: { value: string } }) => {
    //     if (props.disabled) { return }
    //     if (((parseInt(e.target.value) >> 0 && parseInt(e.target.value) <= 31)) || e.target.value === "") {
    //         const val = ['0', props.value[1] === '*' ? '0' : props.value[1], props.value[2] === '*' ? '0' : props.value[2], props.value[3], '1/1', '?', '*']
    //         if (e.target.value === '') {
    //             val[3] = ''
    //         } else {
    //             val[3] = `L-${e.target.value}`
    //         }
    //         props.onChange(val)
    //     }
    // }

    const onAtHourChange = (e: { target: { value: string } }) => {
        if (props.disabled) { return }
        const val = props.value
        val[2] = `${e.target.value}`
        props.onChange(val)
    }

    const onAtMinuteChange = (e: { target: { value: string } }) => {
        if (props.disabled) { return }
        const val = props.value
        val[1] = `${e.target.value}`
        props.onChange(val)
    }

    return (
        <div className='monthly py-4'>
            <div className='flex items-center justify-start'>
                {/* TODO This settings doesnot work with quartz system. Update this in future */}
                {/* <input
                    type="radio"
                    onChange={(e) => {
                        if (props.disabled) return
                        setState({ ...state, every: e.target.value })
                        props.onChange(['0', props.value[1] === '*' ? '0' : props.value[1], props.value[2] === '*' ? '0' : props.value[2], '1', '1/1', '?', '*'])
                    }}
                    value="1"
                    name="MonthlyRadio"
                    checked={state.every === "1" ? true : false}
                    disabled={props.disabled}
                    className='mr-2'
                /> */}
                <div className='text-base mx-2'>{props.translate('Day')}</div>
                <input
                    className={INPUT_FIELD_CLASSNAME + ' w-[100px]'}
                    type="number"
                    value={props.value[3]}
                    min={1}
                    max={31}
                    onChange={onDayChange}
                    disabled={props.disabled}
                />
                <div className='text-base ml-2 w-[150px]'>{props.translate('of every month')}</div>
            </div>
            {/* TODO This settings doesnot work with quartz system. Update this in future */}
            {/* <Separator className='my-3' />
            <div className='flex items-center justify-start'>
                <input
                    onChange={(e) => {
                        if (props.disabled) return
                        setState({ ...state, every: e.target.value })
                        props.onChange(['0', props.value[1] === '*' ? '0' : props.value[1], props.value[2] === '*' ? '0' : props.value[2], 'L', '*', '?', '*'])
                    }}
                    type="radio"
                    value="2"
                    name="DailyRadio"
                    checked={state.every === "2" ? true : false}
                    disabled={props.disabled}
                />
                <div className='text-base ml-2'>{props.translate('Last day of every month')}</div>
            </div>
            <Separator className='my-3' />
            <div className='flex items-center justify-start'>
                <input
                    onChange={(e) => {
                        if (props.disabled) return
                        setState({ ...state, every: e.target.value })
                        props.onChange(['0', props.value[1] === '*' ? '0' : props.value[1], props.value[2] === '*' ? '0' : props.value[2], 'LW', '*', '?', '*'])
                    }}
                    type="radio"
                    value="3"
                    name="DailyRadio"
                    checked={state.every === "3" ? true : false}
                    disabled={props.disabled}
                />
                <div className='text-base ml-2'>{props.translate('On the last weekday of every month')}</div>
            </div>
            <Separator className='my-3' />
            <div className='flex items-center justify-start'>
                <input
                    type="radio"
                    onChange={(e) => {
                        if (props.disabled) return
                        setState({ ...state, every: e.target.value })
                        props.onChange(['0', props.value[1] === '*' ? '0' : props.value[1], props.value[2] === '*' ? '0' : props.value[2], `L-${1}`, '*', '?', '*'])
                    }}
                    value="4"
                    name="MonthlyRadio"
                    checked={state.every === "4" ? true : false}
                    disabled={props.disabled}
                    className='mr-2'
                />
                <input
                    className={INPUT_FIELD_CLASSNAME + ' w-[100px]'}
                    readOnly={state.every !== "4"}
                    type="number"
                    value={props.value[3].split('-').length && props.value[3].split('-')[1] ? props.value[3].split('-')[1] : ''}
                    onChange={onLastDayChange}
                    disabled={props.disabled}
                />
                <div className='text-base ml-2'>{props.translate('day(s) before the end of the month')}</div>
            </div> */}
            <div className='my-4' />
            <div className='text-left font-semibold text-base mb-1'>
                Start Time
            </div>
            <div className='w-full flex flex-row items-center'>
                <HourSelect
                    onChange={onAtHourChange}
                    value={props.value[2]}
                    disabled={props.disabled}
                />
                <div className='mx-4 font-bold'>:</div>
                <MinutesSelect
                    onChange={onAtMinuteChange}
                    value={props.value[1]}
                    disabled={props.disabled}
                />
            </div>
        </div>
    )
}

export default MonthlyCron
